import React, { useCallback, useEffect, useRef, useState } from 'react';

const STORAGE_KEY = 'console.layout.centerRightSplit.v1';

/**
 * Movable horizontal boundary between two adjacent columns (WP-SE-44 amended).
 * Drag adjusts the ratio of available width between left (center column) and right.
 * Mirrors VerticalSplitter.js.
 */
export default function HorizontalSplitter({ onRatioChange, initialRatio = 0.75 }) {
    const [ratio, setRatio] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            return saved ? parseFloat(saved) : initialRatio;
        } catch { return initialRatio; }
    });
    const dragging = useRef(false);

    useEffect(() => {
        try { localStorage.setItem(STORAGE_KEY, String(ratio)); } catch { /* storage full */ }
        onRatioChange?.(ratio);
    }, [ratio, onRatioChange]);

    // Initial callback so parent gets the persisted value
    useEffect(() => { onRatioChange?.(ratio); }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleMouseDown = useCallback((e) => {
        e.preventDefault();
        dragging.current = true;
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
    }, []);

    useEffect(() => {
        const onMove = (e) => {
            if (!dragging.current) return;
            const splitter = document.querySelector('[data-horizontal-splitter]');
            if (!splitter) return;
            const container = splitter.parentElement;
            if (!container) return;
            const rect = container.getBoundingClientRect();
            const newRatio = Math.max(0.4, Math.min(0.9, (e.clientX - rect.left) / rect.width));
            setRatio(newRatio);
        };
        const onUp = () => {
            dragging.current = false;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        return () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
    }, []);

    return (
        <div
            data-horizontal-splitter
            onMouseDown={handleMouseDown}
            style={{
                width: 6, cursor: 'col-resize',
                background: '#E8EAED', borderRadius: 3,
                margin: '0 2px', flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
        >
            <div style={{ width: 2, height: 32, background: '#BDC1C6', borderRadius: 1 }} />
        </div>
    );
}
